import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalSearch.GlobalSearchLoadingState'

export default defineMessages({
  loadingMessage: {
    id: `${scope}.loadingMessage`,
    defaultMessage: 'Finding relevant results...',
  },
})
